import { useMemo } from 'react';
import { getDyanmicFormData } from '../utils';
import type { FormField } from '../typings';

export const useDynamicForm = (formData?: FormField[]) => {
  return useMemo(() => getDyanmicFormData(formData), [formData]);
};
